import { COUNTRIES } from "@Components/LeadFormV2/constants";
import { PHONE_1, PHONE_2, PHONE_3, PHONE_4 } from "constants/index";

const getCountryNumber = (country: string) => {
  switch (country) {
    case COUNTRIES.GB:
      return PHONE_1.full_number;
    case COUNTRIES.IN:
      return PHONE_2.full_number;
    case COUNTRIES.US:
      return PHONE_3.full_number;
    case COUNTRIES.AU:
      return PHONE_4.full_number;
    default:
      return PHONE_2.full_number;
  }
};
export default getCountryNumber;
